// rel="noopener" kept as in the design (noreferrer would hide the referrer from stores/WhatsApp)
/* eslint-disable react/jsx-no-target-blank */
import { useHomeText } from '../text';

const SiteHeader = () => {
  const t = useHomeText();
  return (
    <header className="kh-header" style={{ position: "sticky", top: "0", zIndex: "20", background: "rgba(11,18,64,0.94)", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "12px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px", flexWrap: "wrap" }}>
        <a href="#top" aria-label={t.header.khotouaHomeLabel} style={{ display: "flex", alignItems: "center" }}>
          <img width="204" height="130" src="/assets/img/logo-khotoua.webp" alt={t.header.khotouaLogoAlt} style={{ height: "48px", width: "auto", display: "block" }} />
        </a>
        <button type="button" className="kh-burger" aria-controls="kh-menu" aria-expanded="false" aria-label={t.header.menuLabel}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
            <path d="M4 7h16M4 12h16M4 17h16" />
          </svg>
        </button>
        <nav id="kh-menu" className="kh-nav" aria-label={t.header.mainMenuLabel} style={{ display: "flex", gap: "22px", flexWrap: "wrap", fontWeight: "600", fontSize: "15px" }}>
          <a href="#about" style={{ color: "#E6E9FF", textDecoration: "none" }}>
            {t.header.aboutUs}
          </a>
          <a href="#contents" style={{ color: "#E6E9FF", textDecoration: "none" }}>
            {t.header.learningContent}
          </a>
          <a href="#features" style={{ color: "#E6E9FF", textDecoration: "none" }}>
            {t.header.features}
          </a>
          <a href="#schools" style={{ color: "#E6E9FF", textDecoration: "none" }}>
            {t.header.forSchools}
          </a>
          <a href="#trust" style={{ color: "#E6E9FF", textDecoration: "none" }}>
            {t.header.testimonials}
          </a>
          <a href="#pricing" style={{ color: "#E6E9FF", textDecoration: "none" }}>
            {t.header.plans}
          </a>
          <a href="#contact" style={{ color: "#E6E9FF", textDecoration: "none" }}>
            {t.header.contact}
          </a>
          <div className="kh-nav-lang">
            <a href="/" hrefLang="ar" lang="ar" data-lang="ar" aria-current={t.header.arabicCurrent} style={t.header.arabicStyle}>
              العربيّة
            </a>
            {" · "}
            <a href="/fr/" hrefLang="fr" lang="fr" data-lang="fr" style={t.header.francaisStyle} aria-current={t.header.francaisCurrent}>
              Français
            </a>
            {" · "}
            <a href="/en/" hrefLang="en" lang="en" data-lang="en" style={t.header.englishStyle} aria-current={t.header.englishCurrent}>
              English
            </a>
          </div>
        </nav>
        <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
          <span className="kh-lang" style={{ display: "inline-flex", alignItems: "center", minHeight: "44px", padding: "0 12px", color: "#C9CEF5", textDecoration: "none", fontWeight: "600", fontSize: "14px", gap: "6px" }}>
            <a href="/" hrefLang="ar" lang="ar" data-lang="ar" aria-current={t.header.arCurrent} style={t.header.arStyle}>
              AR
            </a>
            {" · "}
            <a href="/fr/" hrefLang="fr" lang="fr" data-lang="fr" style={t.header.frStyle} aria-current={t.header.frCurrent}>
              FR
            </a>
            {" · "}
            <a href="/en/" hrefLang="en" lang="en" data-lang="en" style={t.header.enStyle} aria-current={t.header.enCurrent}>
              EN
            </a>
          </span>
          <button type="button" className="kh-parent" data-soon={t.header.parentSpaceSoon} data-track="parent_space_click" style={{ display: "inline-flex", alignItems: "center", gap: "8px", minHeight: "44px", padding: "0 16px", borderRadius: "999px", border: "1.5px solid rgba(255,255,255,0.35)", background: "transparent", color: "#FFFFFF", fontWeight: "700", cursor: "pointer" }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 21c1.500-4 4.500-6 8-6s6.500 2 8 6" />
            </svg>
            <span>
              {t.header.parentSpace}
            </span>
          </button>
          <a href="https://play.google.com/store/apps/details?id=com.DMNovaComany.Khotoua&pcampaignid=web_share" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", minHeight: "44px", padding: "0 20px", borderRadius: "999px", background: "#46D3BE", color: "#0B1240", fontWeight: "800", textDecoration: "none", boxShadow: "0 4px 0 rgba(0,0,0,0.25)" }}>
            {t.header.getTheApp}
          </a>
        </div>
      </div>
    </header>
  );
};

export default SiteHeader;
